/*
 * SortableTableColumnHeader.jsx
 */

import React from 'react';
import PropTypes from 'prop-types';
import * as Icons from '../icons/Icons';
import announce from '../../../helpers/annouce';

const propTypes = {
    name: PropTypes.string,
    id: PropTypes.string,
    isSorted: PropTypes.bool,
    isAsc: PropTypes.bool,
    onSortToggle: PropTypes.func
};

const defaultProps = {
    name: "",
    id: '',
    isSorted: false,
    isAsc: null
};

export default class SortableTableColumnHeader extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            isSorted: props.isSorted,
            isAsc: props.isAsc
        };
        this.onSortToggle = this.onSortToggle.bind(this);
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.isSorted !== this.state.isSorted) {
            this.setState({
                isSorted: nextProps.isSorted
            });
        }
        if (nextProps.isAsc !== this.state.isAsc) {
            this.setState({
                isAsc: nextProps.isAsc
            });
        }
    }

    onSortToggle() {
        const isAsc = !this.state.isAsc;
        
        announce(`Sorted by ${this.props.name}: ${isAsc ? "ascending" : "descending"}`);
        
        if (this.state.isSorted) {
            this.setState({
                isAsc
            }, () => {
                this.props.onSortToggle(this.state.isSorted, this.state.isAsc, this.props.id);
            });
        }
        else {
            this.setState({
                isSorted: true,
                isAsc: true
            }, () => {
                this.props.onSortToggle(this.state.isSorted, this.state.isAsc, this.props.id);
            });
        }
    }

    render() {
        const { isSorted, isAsc } = this.state;
        
        let sortArrows = null;

        if (this.state.isSorted) {
            if (this.state.isAsc) {
                sortArrows = (
                    <div className="sort">
                        <div className="disabled">
                            <Icons.IconArrowUp alt="" />
                        </div>
                        <div className="sorted">
                            <Icons.IconArrowDown alt="" />
                        </div>
                    </div>
                );
            }
            else {
                sortArrows = (
                    <div className="sort">
                        <div className="sorted">
                            <Icons.IconArrowUp alt="" />
                        </div>
                        <div className="disabled">
                            <Icons.IconArrowDown alt="" />
                        </div>
                    </div>
                );
            }
        }
        else {
            sortArrows = (
                <div className="sort">
                    <div className="enabled">
                        <Icons.IconArrowUp alt="" />
                    </div>
                    <div className="enabled">
                        <Icons.IconArrowDown alt="" />
                    </div>
                </div>
            );
        }
        
        let sort = null;
        if (isSorted) {
            sort = isAsc ? "ascending" : "descending";
        }

        return (
            <th className="sortable-column-header" aria-sort={sort} role="columnheader">
                <button onClick={this.onSortToggle}>
                    <span className="title">
                        {this.props.name}
                    </span>
                    {sortArrows}
                </button>
            </th>
        );
    }
}

SortableTableColumnHeader.propTypes = propTypes;
SortableTableColumnHeader.defaultProps = defaultProps;

